import React, { FC } from "react";
import { Platform, StyleProp, StyleSheet, View, ViewStyle } from "react-native";
import Animated from "react-native-reanimated";
import { Layout as UiLayout, LayoutProps as UiLayoutProps } from "@lookiero/sty-psp-ui";
import { style } from "./Layout.style";
import { useHideHeaderOnScroll } from "./useHideHeaderOnScroll";

interface LayoutProps extends UiLayoutProps {
  readonly layout: UiLayout;
}

const Layout: FC<LayoutProps> = ({
  children,
  layout: Layout,
  header,
  footer,
  scrollRef,
  style: customStyle,
  onScroll,
  ...props
}) => {
  const { headerAnimatedStyle, scrollViewAnimatedStyle, handleOnScroll } = useHideHeaderOnScroll({ onScroll });

  return (
    <Layout
      {...props}
      header={Platform.OS !== "web" ? null : undefined}
      scrollEnabled={Platform.OS !== "web"}
      stickyHeader={Platform.OS !== "web"}
      style={{
        safeAreaView: customStyle?.safeAreaView,
        header: [
          customStyle?.header,
          Platform.OS === "web" && [style.header, headerAnimatedStyle],
        ] as StyleProp<ViewStyle>,
        scrollView: customStyle?.scrollView,
      }}
    >
      <Animated.ScrollView
        // @ts-ignore
        ref={scrollRef}
        contentContainerStyle={style.contentContainer}
        scrollEventThrottle={16}
        showsVerticalScrollIndicator={false}
        stickyHeaderIndices={[0]}
        style={[StyleSheet.absoluteFill, Platform.OS === "web" && [headerAnimatedStyle, scrollViewAnimatedStyle]]}
        testID="look-in-scroll-view"
        onScroll={handleOnScroll}
      >
        {header}

        {children}
      </Animated.ScrollView>

      <View style={[style.footer, customStyle?.footer]}>{footer}</View>
    </Layout>
  );
};

export type { LayoutProps };
export { Layout };
